var map = {
	"./0 a.png": 2363,
	"./0.png": 2364,
	"./1 a.png": 2365,
	"./1.png": 2366,
	"./2 a.png": 2367,
	"./2.png": 2368,
	"./3 a.png": 2369,
	"./3.png": 2370,
	"./4 a.png": 2371,
	"./4.png": 2372,
	"./5 a.png": 2373,
	"./5.png": 2374,
	"./6 a.png": 2375,
	"./6.png": 2376,
	"./7 a.png": 2377,
	"./7.png": 2378,
	"./8 a.png": 2379,
	"./8.png": 2380,
	"./9 a.png": 2381,
	"./9.png": 2382,
	"./BG new 2.png": 2383,
	"./CEX.png": 2384,
	"./Copy of token-05.png": 2385,
	"./DEX.png": 2386,
	"./FBlogo.png": 2387,
	"./Group 126.png": 846,
	"./Group 127.png": 2388,
	"./Group 128.png": 2389,
	"./Group 129.png": 2390,
	"./Group 130.png": 2391,
	"./Group 131.png": 2392,
	"./Group 160.png": 2393,
	"./Group 161.png": 2394,
	"./Group 164.png": 2395,
	"./Group 4.png": 2396,
	"./Group 5.png": 2397,
	"./Group 6.png": 2398,
	"./Group 7.png": 2399,
	"./Group-5.png": 2400,
	"./Group-6.png": 2401,
	"./Group-7.png": 2402,
	"./Group120.png": 849,
	"./Indexx Token.png": 2403,
	"./IndexxToken.png": 2404,
	"./Polygon.png": 2405,
	"./about.png": 2406,
	"./affiliate.png": 2407,
	"./aline.png": 2408,
	"./assets/1.png": 2409,
	"./assets/2.png": 2410,
	"./assets/3.png": 2411,
	"./assets/4.png": 2412,
	"./assets/ADA.png": 2413,
	"./assets/ALGO.png": 2414,
	"./assets/BNB.png": 2415,
	"./assets/BTC.png": 2416,
	"./assets/BTCB.png": 2417,
	"./assets/Ball-024-01png.png": 2418,
	"./assets/CEX.png": 2419,
	"./assets/DEX.png": 2420,
	"./assets/ENJ.png": 2421,
	"./assets/ETH.png": 2422,
	"./assets/FBlogo.png": 2423,
	"./assets/FTT.png": 2424,
	"./assets/IN500.png": 2425,
	"./assets/INEX.png": 2426,
	"./assets/INXC.png": 2427,
	"./assets/INXP.png": 2428,
	"./assets/IUSD+.png": 2429,
	"./assets/IUSD.png": 2430,
	"./assets/Indexx Token.png": 2431,
	"./assets/LTC.png": 2432,
	"./assets/ML.png": 2433,
	"./assets/Polygon.png": 2434,
	"./assets/UI-bg.png": 2435,
	"./assets/UNI.png": 2436,
	"./assets/USD.png": 2437,
	"./assets/Wales.png": 2438,
	"./assets/about.png": 2439,
	"./assets/affiliate.png": 2440,
	"./assets/arrows.png": 2441,
	"./assets/bank.png": 2442,
	"./assets/bg33.png": 2443,
	"./assets/bgForUi.png": 2444,
	"./assets/binancew.png": 2445,
	"./assets/blog.png": 2446,
	"./assets/bnb1.png": 2447,
	"./assets/bnblogo2.png": 2448,
	"./assets/cam2 copy.png": 2449,
	"./assets/cam2.png": 2450,
	"./assets/career.png": 2451,
	"./assets/clock.png": 2452,
	"./assets/coinbase2.png": 2453,
	"./assets/confirm.png": 2454,
	"./assets/confirm1.png": 2455,
	"./assets/dex4t2e copy.png": 2456,
	"./assets/dex4t2e.png": 2457,
	"./assets/dollar.png": 2458,
	"./assets/earn.png": 2459,
	"./assets/eth1.png": 2460,
	"./assets/exchange.png": 2461,
	"./assets/exchange1.png": 2462,
	"./assets/exgcoin.png": 2463,
	"./assets/exghands.png": 2464,
	"./assets/fb.png": 2465,
	"./assets/fortune Daily.png": 2466,
	"./assets/fortune-10.png": 2467,
	"./assets/fortune-12.png": 2468,
	"./assets/four.png": 2469,
	"./assets/graph.png": 2470,
	"./assets/green.png": 2471,
	"./assets/green2.png": 2472,
	"./assets/green3.png": 2473,
	"./assets/green4.png": 2474,
	"./assets/header-icons/Company/about.png": 2475,
	"./assets/header-icons/Company/affiliate.png": 2476,
	"./assets/header-icons/Company/blog.png": 2477,
	"./assets/header-icons/Company/career.png": 2478,
	"./assets/header-icons/Company/howitworks.png": 2479,
	"./assets/header-icons/Company/hybrid.png": 2480,
	"./assets/header-icons/Earn/iGrow.png": 2481,
	"./assets/header-icons/Earn/t2e.png": 2482,
	"./assets/header-icons/Fortune/fortune.png": 2483,
	"./assets/header-icons/Fortune/hedge.png": 2484,
	"./assets/header-icons/Products/CEX.png": 2485,
	"./assets/header-icons/Products/DEX.png": 2486,
	"./assets/header-icons/Products/IndexxToken.png": 2487,
	"./assets/header.png": 2488,
	"./assets/hedge.png": 2489,
	"./assets/how it works.png": 2490,
	"./assets/hybrid.png": 2491,
	"./assets/iGrow.png": 2492,
	"./assets/indexx.png": 2493,
	"./assets/indexx500.png": 2494,
	"./assets/indexxGrey.png": 2495,
	"./assets/inst2.png": 2496,
	"./assets/ladySwapIcon.png": 2497,
	"./assets/logo.png": 2498,
	"./assets/logonew.png": 2499,
	"./assets/metamask.png": 2500,
	"./assets/need.png": 2501,
	"./assets/new.png": 2502,
	"./assets/newFooter.png": 2503,
	"./assets/no11.png": 2504,
	"./assets/no22.png": 2505,
	"./assets/no3.png": 2506,
	"./assets/one.png": 2507,
	"./assets/pending.png": 2508,
	"./assets/pending1.png": 2509,
	"./assets/petFooter.png": 2510,
	"./assets/please.png": 2511,
	"./assets/qr.png": 2512,
	"./assets/question.png": 2513,
	"./assets/redit2.png": 2514,
	"./assets/send1.png": 2515,
	"./assets/sending.png": 2516,
	"./assets/swap.png": 2517,
	"./assets/telegram.png": 2518,
	"./assets/text.png": 2519,
	"./assets/three.png": 2520,
	"./assets/trust.png": 2521,
	"./assets/twit2.png": 2522,
	"./assets/two.png": 2523,
	"./assets/vector.png": 2524,
	"./assets/wallet.png": 2525,
	"./assets/white copy.png": 2526,
	"./assets/white.png": 2527,
	"./assets/yt1.png": 2528,
	"./bank.png": 2529,
	"./bg33.png": 2530,
	"./blog.png": 2531,
	"./buy.png": 2532,
	"./buyi.png": 2533,
	"./cam2.png": 2534,
	"./career.png": 2535,
	"./changed.png": 2536,
	"./checkorange.png": 2537,
	"./cross.png": 2538,
	"./dex4t2e.png": 2539,
	"./down.png": 2540,
	"./editt.png": 2541,
	"./fortune-10.png": 2542,
	"./fortune-16.png": 2543,
	"./fortune.png": 2544,
	"./fourthh.png": 2545,
	"./gggg.png": 1126,
	"./graph.png": 2546,
	"./hands-12.png": 2547,
	"./hands-20.png": 2548,
	"./hands-29.png": 2549,
	"./hedge.png": 2550,
	"./home_page_logo.png": 2551,
	"./howitworks.png": 2552,
	"./htp.png": 2553,
	"./htp2.png": 2554,
	"./htp2n.png": 2555,
	"./htpf.png": 1123,
	"./hybrid.png": 2556,
	"./iGrow.png": 2557,
	"./icons.png": 2558,
	"./image1.png": 2559,
	"./image2.png": 2560,
	"./image3.png": 2561,
	"./indexx.png": 2562,
	"./indexxGrey.png": 2563,
	"./inst2.png": 2564,
	"./lady.png": 2565,
	"./ladySwapIcon.png": 2566,
	"./left.png": 847,
	"./left22.png": 2567,
	"./log.png": 1127,
	"./logo.png": 2568,
	"./mid.png": 2569,
	"./need copy.png": 2570,
	"./need.png": 2571,
	"./new.png": 2572,
	"./newFooter.png": 2573,
	"./pf.png": 2574,
	"./pfF.png": 2575,
	"./pfp.png": 2576,
	"./pfp2.png": 2577,
	"./ppp.png": 2578,
	"./prize funds new.png": 1125,
	"./purple-1.png": 2579,
	"./purple.png": 2580,
	"./redit2.png": 2581,
	"./right.png": 848,
	"./right22.png": 2582,
	"./secondd.png": 2583,
	"./stars 1.png": 2584,
	"./t2e.png": 2585,
	"./telegram.png": 2586,
	"./thirdd.png": 2587,
	"./ticket.png": 2588,
	"./token.png": 2589,
	"./tokenimgg.png": 2590,
	"./top.png": 850,
	"./topp.png": 2591,
	"./twit2.png": 2592,
	"./wc.png": 2593,
	"./wcF.png": 1124,
	"./whale4.png": 1128,
	"./white.png": 2594,
	"./x orange.png": 2595,
	"./yt1.png": 2596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 422;